import { getDefaults } from '../../routes/events/state/events-query'
import { SET_EVENTS_FILTER, SET_EVENT_VIEW_TYPE, SET_EVENTS_EXPANDED, SET_CALENDAR_VIEW_TYPE, SET_CALENDAR_LAST_DATE } from './types'
import QueryStringIO from '../../routes/events/lib/query-string-io'
import { DATE_FORMATS } from '../../utils/Formatter'

import moment from 'moment'
import { endOfDay, startOfDay } from 'date-fns'
import qs from '../../utils/QueryString'
import Storage from '../../utils/Storage'
import { EVENT_VIEW_TYPES } from './reducers'
import actions from '../actions'

// search keys that must be passed to be included in the search, otherwise the default is used
const optionalKeys = [
  'title',
  'description',

  'eventID',
  'customID',

  'keywords',
  'anyCategories',

  'resultMax',
]

export const setEventsFilter = (payload, merge) => {
  return (dispatch, getState) => {
    const state = getState()
    const defaults = getDefaults(state)
    let filters = { ...(payload || defaults) }
    if (payload === null) {
      payload = defaults
    }
    if (merge) {
      filters = { ...state.events.filters, ...payload }
    }
    optionalKeys.forEach((key) => {
      // these keys must be specifically requested to be used in the query, otherwise the default is used
      if (!payload[key]) {
        delete filters[key]
        if (defaults[key]) {
          filters[key] = defaults[key]
        }
      }
    })
    if (filters.startDateTime) {
      filters.startDateTime = startOfDay(
        moment(filters.startDateTime).format(DATE_FORMATS.apiDateFormat)
      ).toISOString()
    } else if (!filters.customID || !filters.eventID) {
      // if there is no startdate and we aren't searching for a specific event (which don't need startdate) use the default range
      filters.startDateTime = startOfDay(
        moment(defaults.startDateTime).format(DATE_FORMATS.apiDateFormat)
      ).toISOString()
    }
    if (filters.stopDateTime) {
      filters.stopDateTime = endOfDay(
        moment(filters.stopDateTime).format(DATE_FORMATS.apiDateFormat)
      ).toISOString()
    } else if (!filters.customID || !filters.eventID) {
      // if there is no stop date and we're not searching for a specific event use the default range
      filters.stopDateTime = endOfDay(
        moment(defaults.stopDateTime).format(DATE_FORMATS.apiDateFormat)
      ).toISOString()
    }
    if (filters.getOnlyPrivate === 'false') {
      filters.getOnlyPrivate = false
    }
    qs.set(QueryStringIO._createParams(filters, defaults))
    dispatch({
      type: SET_EVENTS_FILTER,
      payload: filters,
    })
  }
}

export const setEventViewType = (payload) => {
  return (dispatch) => {
    Storage.set('EVENT_VIEW_TYPE', payload.type)
    dispatch({ type: SET_EVENT_VIEW_TYPE, payload })
    if (payload.type === EVENT_VIEW_TYPES.EXPANDED.key) {
      dispatch(actions.data.requestEvents())
    }
  }
}

export const setEventsExpanded = payload => {
  return dispatch => {
    dispatch({ type: SET_EVENTS_EXPANDED, payload })
  }
}

export const setCalendarViewType = payload => {
  return dispatch => {
    dispatch({ type: SET_CALENDAR_VIEW_TYPE, payload })
  }
}

export const setCalendarLastDate = payload => {
  return dispatch => {
    dispatch({ type: SET_CALENDAR_LAST_DATE, payload })
  }
}
